// Use compiled gatsby-browser.js
module.exports = require('./dist/gatsby-browser')
